const Config = {
  base_url: window.appEnv.API_URL,
  firebase: window.appEnv.FIREBASE,
  socket_url: window.appEnv.SOCKET_URL,
};

export default Config;
